import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FiHome, FiUser, FiSettings, FiBarChart, FiGlobe, FiLogOut, FiShoppingBag, FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const DashboardLayout = ({ children }) => {
  const location = useLocation();
  const { logout } = useAuth();

  const navigation = [
      { name: 'Dashboard', href: '/dashboard', icon: FiHome },
      { name: 'Profile', href: '/profile', icon: FiUser },
      { name: 'Connections', href: '/connections', icon: FiUsers },
      { name: 'Analytics', href: '/analytics', icon: FiBarChart },
      { name: 'Store', href: '/store', icon: FiShoppingBag },
      { name: 'Settings', href: '/settings', icon: FiSettings },
  ];

  return (
    <div className="min-h-screen bg-dark-950">
      {/* Sidebar */}
      <div className="fixed inset-y-0 left-0 z-50 w-64 glass-dark border-r border-white/10">
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="flex items-center px-6 py-4 border-b border-white/10">
            <img 
              src="/HubID Logo White.svg" 
              alt="HubID" 
              className="h-8"
            />
          </div>

          {/* Navigation */}
          <nav className="flex-1 px-4 py-6 space-y-1">
            {navigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-all ${
                    isActive
                      ? 'glass-orange text-orange-400 border border-orange-500/30'
                      : 'text-gray-400 hover:text-white hover:glass border border-transparent'
                  }`}
                >
                  <SafeIcon icon={item.icon} className="mr-3 text-lg" />
                  {item.name}
                </Link>
              );
            })}
          </nav>

          {/* Logout */}
          <div className="px-4 py-6 border-t border-white/10">
            <button
              onClick={logout}
              className="flex items-center w-full px-4 py-3 text-sm font-medium text-gray-400 rounded-lg hover:text-white hover:glass transition-all border border-transparent hover:border-white/10"
            >
              <SafeIcon icon={FiLogOut} className="mr-3 text-lg" />
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="pl-64">
        <main className="p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
